<template>
  <v-text-field
    label="Ingrese direcciòn"
    outlined
    dense
    hide-details
    v-model="address"
    readonly
    @focus="onInputClick"
  >
    <template #append>
      <v-icon>mdi-magnify</v-icon>
    </template>
  </v-text-field>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import AddItemModal from '../modals/new-order/AddItemModal.vue';
  import { IOrderItem } from '../../interfaces/IOrderItem';
  import AddressLookupModal from '../modals/AddressLookupModal.vue';
  import { IBranch } from '../../interfaces/IBranch';
  import { debounce } from '../../utils';

  @Component
  export default class AddressInput extends Vue {
    @Prop() branch: IBranch;
    @Prop({ default: true }) detailed: boolean;
    @Prop() value?: {
      address: string;
      address2: string;
      comments: string;
      lat: number;
      lng: number;
    };
    address: string = null;
    address2: string = null;
    comments: string = null;
    lat: number = null;
    lng: number = null;
    showAddressLookup = null;

    @Watch('value', { immediate: true })
    onValueChanged() {
      if (this.value) {
        this.address = this.value.address;
        this.address2 = this.value.address2;
        this.comments = this.value.comments;
        this.lat = this.value.lat;
        this.lng = this.value.lng;
      }
    }

    async created() {
      this.showAddressLookup = debounce(() => {
        this.$modal.show(
          AddressLookupModal,
          {
            branch: this.branch,
            fullPosition: this.detailed,
          },
          {
            name: 'add-item',
            adaptive: true,
            classes: 'dialog--height-limit',
            height: 'auto',
            //width: 1000,
            scrollable: true,
            maxWidth: window.innerWidth * 0.95,
          },
          {
            set: (pos: {
              lat: number;
              lng: number;
              address: string;
              address2: string;
              comments: string;
            }) => {
              this.address = pos.address;
              this.address2 = pos.address2;
              this.comments = pos.comments;
              this.lat = pos.lat;
              this.lng = pos.lng;
              this.save();
            },
          }
        );
      }, 100);
    }

    onInputClick() {
      this.showAddressLookup();
    }

    save() {
      if (!this.address || (this.detailed && !this.lat)) return;
      this.$emit('change', {
        address: this.address,
        address2: this.address2,
        comments: this.comments,
        lat: this.lat,
        lng: this.lng,
      });
    }
  }
</script>
